import { render } from "./CommercialConcessionView.vue?vue&type=template&id=b5c77cac&scoped=true"
import script from "./CommercialConcessionView.vue?vue&type=script&lang=js"
export * from "./CommercialConcessionView.vue?vue&type=script&lang=js"

import "@/assets/css/app.a60e7e5f.css?vue&type=style&index=0&id=b5c77cac&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c77cac"]])

export default __exports__